import { render } from "./ContentWrapperControl.vue?vue&type=template&id=78a17e3a"
import script from "./ContentWrapperControl.vue?vue&type=script&lang=js"
export * from "./ContentWrapperControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__